import { render, staticRenderFns } from "./windSpeed.vue?vue&type=template&id=7fde70b6"
import script from "./windSpeed.vue?vue&type=script&lang=js"
export * from "./windSpeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports